import { useMemo } from 'react';
import { useAccess } from './useAccess';

/**
 * Per-module RBAC helpers built on session featureKeys + payment lock.
 * Prefix examples: `warehouse`, `staff`, `procurement.sales`, `chamber`.
 */
export function useModuleAccess(prefix: string) {
  const { can, canMutate } = useAccess();

  return useMemo(() => {
    const key = (action: string) => `${prefix}.${action}`;
    return {
      canView: can(key('view')),
      canCreate: canMutate(key('create')),
      canUpdate: canMutate(key('update')),
      canDelete: canMutate(key('delete')),
      canApprove: canMutate(key('approve')),
      canConfirm: canMutate(key('confirm')),
      canViewAll: can(key('view_all')),
      can: (action: string) => can(key(action)),
      canMutateAction: (action: string) => canMutate(key(action)),
    };
  }, [can, canMutate, prefix]);
}
